module.exports = __webpack_public_path__ + "media/images/profile/not-match-icon-0647fd8bdee5e51430f82dd7c1abcf7c.svg";